
import { createSlice } from '@reduxjs/toolkit';
import { service } from '../shared/_services/api_service';
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const STATUS = Object.freeze({
  IDLE: 'idle',
  ERROR: 'error',
  LOADING: 'loading',
});

const initialState = {
  loadingStatus: STATUS.IDLE,
  error: '',
  isOpenModal: false,
  slidersData: [],
  slidersCount: 0
};

export const testSlice = createSlice({
  name: 'test',
  initialState,
  reducers: {
    setSliders(state, { payload }) {
      state.slidersData = payload.result;
      state.slidersCount = payload.count;
    },
    pushSlider(state, { payload }) {
      state.slidersData.push(payload);
      state.slidersCount = state.slidersCount + 1;
    },
    sliceSlider(state, { payload }) {
      const objIndex = state.slidersData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.slidersData.splice(objIndex, 1)
      }
      state.slidersCount -= 1;

    },
    updateSliderInState(state, { payload }) {
      const idx = state.slidersData.findIndex((obj) => obj._id === payload._id);
      if (idx >= 0) {
        state.slidersData[idx] = payload;
      }
    },


    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },

  },
});

export const { setSliders, pushSlider, sliceSlider, updateSliderInState, isOpenModal, ModalToggle, } = testSlice.actions;
export default testSlice.reducer;

export function fetchSliders(limit, offset) {
  return async function fetchTestsThunk(dispatch, getState) {
    try {
      await service.getSliders(limit, offset).then(
        (response) => {
          dispatch(setSliders(response.data));
        }, (error) => {
        }
      );

    } catch (err) {

    }
  }
}




export function addSlider(data, image) {
  return async function addSliderThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      const response = await service.addSlider(data)
      if (response.data) {
        const imageResponse = await service.addImageToSlider(response.data._id, image);
        dispatch(pushSlider(imageResponse.data))
      }
      dispatch(ModalToggle())
      dispatch(setLoading(false))
      successHandler('Added Successfully')


    } catch (err) {

    }
  }
}

export function deleteSlider(data) {
  return async function deleteSliderThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteSlider(data).then(
        (response) => {
          dispatch(sliceSlider(data))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function editSlider(id, data, image) {
  return async function editSliderThunk(dispatch) {
    try {
      dispatch(setLoading(true));
      const response = await service.updateSlider(id, data, image);
      if (response.data) {
        dispatch(updateSliderInState(response.data));
      }
      dispatch(ModalToggle());
      dispatch(setLoading(false));
      successHandler('Updated Successfully');
    } catch (err) {
      dispatch(setLoading(false));
      errorHandler(err.response);
    }
  };
}
